import PropTypes from 'prop-types'
import { routerPropTypes } from 'Types'
import React from 'react'
import { SuggestionsTemplate } from 'Blocks'
import config from 'Config'

const NoSearchMessage = props => {
  const queryString = props.location.search
  const term = queryString.match(/term=([^&]*)/)[1]
  return (
    <div className="no-search__info">
      <h2>
        {config.locale === 'de' ? 'Keine Treffer gefunden' : 'No matches found'}
      </h2>
      <p className="no-search__spacing">
        {`${
          config.locale === 'de'
            ? 'Es konnten keine Treffer zu Ihren Suchkriterien gefunden werden:'
            : 'We couldn’t find any results to match your search:'
        } ${term}
        `}
      </p>
      <p>
        {config.locale === 'de'
          ? 'Aber geben Sie nicht auf - versuchen Sie es einfach mit einem allgemeiner formulierten Suchbegriff oder stöbern Sie in den unten stehenden Kategorien'
          : 'But don’t give up - simply try a more generic search term or browse from the categories below.'}
      </p>
    </div>
  )
}

NoSearchMessage.propTypes = {
  ...routerPropTypes
}

const NoSearch = props => (
  <div className={`${props.className}`}>
    <SuggestionsTemplate {...props}>
      <NoSearchMessage {...props} />
    </SuggestionsTemplate>
  </div>
)

NoSearch.propTypes = {
  className: PropTypes.string
}

export default NoSearch
